import FeathersHelper from "../../helpers/feathers";

export const find = (payload) =>
  FeathersHelper.find('questions', payload);
export const create = (payload) =>
  FeathersHelper.create('questions', payload);
export const patch = (id, payload, params = {}) => FeathersHelper.patch('questions', id, payload, params);
export const remove = (id, params = {}) => FeathersHelper.remove('questions', id, params);

